"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// import dynamic from "next/dynamic";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 30 * 1000, // 30 seconds
			gcTime: 5 * 60 * 1000, // 5 minutes
		},
	},
});

// const ReactQueryDevtools = dynamic(() => import("@tanstack/react-query-devtools").then((mod) => mod.ReactQueryDevtools), {
// 	ssr: false,
// });

export default function QueryProvider({ children }: { children: React.ReactNode }) {
	return (
		<QueryClientProvider client={queryClient}>
			{children}
			{/* {process.env.NODE_ENV === "development" && <ReactQueryDevtools initialIsOpen={false} buttonPosition="relative" />} */}
		</QueryClientProvider>
	);
}
